import gql from "graphql-tag";
const getUserProfiles = gql(` 
query getUserProfiles($user: String!, $type: String!) {
  getUserProfiles(user: $user, type: $type) {
  data
  }
}
`)
export default getUserProfiles;
